import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { ThemaIcon } from "../../atoms/icons/ThemaIcon";
import { useTranslation } from 'react-i18next';



// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string>;
export const Thema = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tDatatypes } = useTranslation('datatypes');
    
    const label = props.label || tDatatypes('themaLabel') || "Thema";
    return (<Caption {...props} caption={label} icon={<ThemaIcon />}>
        {props.value}
    </Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));